import { useState, useEffect } from 'react';

export function useTypingEffect(
  texts: string[],
  typingSpeed = 100,
  deletingSpeed = 50,
  pauseDuration = 2000
) {
  const [currentText, setCurrentText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTyping, setIsTyping] = useState(true);

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    if (isTyping) {
      if (currentText === texts[currentIndex]) {
        // Pause at the end of typing
        timeout = setTimeout(() => {
          setIsTyping(false);
        }, pauseDuration);
      } else {
        // Type the next character
        timeout = setTimeout(() => {
          setCurrentText(texts[currentIndex].slice(0, currentText.length + 1));
        }, typingSpeed);
      }
    } else {
      if (currentText === '') {
        // Move to next text
        setCurrentIndex((current) => (current + 1) % texts.length);
        setIsTyping(true);
      } else {
        // Delete the last character
        timeout = setTimeout(() => {
          setCurrentText(currentText.slice(0, -1));
        }, deletingSpeed);
      }
    }

    return () => clearTimeout(timeout);
  }, [currentText, currentIndex, isTyping, texts, typingSpeed, deletingSpeed, pauseDuration]);

  return currentText;
}